import { useCallback } from 'react'
import { useFetch } from './useFetch'


export const useDashboardService = () => {
  const fetch = useFetch()

  const simulateNetworkDelay = async (ms = 500) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }


  const getPastSixMonths = () => {
    const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    const today = new Date()
    const months = []
    for (let i = 5; i >= 0; i--) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1)
      months.push(monthNames[d.getMonth()])
    }
    return months
  }


  const getCadaveresDiaAsync = useCallback(async (setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/cadaver/estatistica/pordia')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesDiaAsync = useCallback(async (setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/pordia')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getVestigiosDiaAsync = useCallback(async (setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/vestigios/estatistica/total/pordia')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getVestigiosSetorAsync = useCallback(async (sectorId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get(`/vestigios/estatistica/porsetor/${sectorId}`)
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getVestigiosUsuarioAsync = useCallback(async (userId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get(`/vestigios/estatistica/porusuario/${userId}`)
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesAtribuidosUsuarioAsync = useCallback(async (userId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/dousuario/porstatus')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesSolicitadosSetorAsync = useCallback(async (sectorId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get(`/exameSolicitado/estatistica/dosetor/porstatus/${sectorId}`)
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])


  // --- Chart Fetches (Temporal series, past 6 months) ---

  const getCadaveresMesAsync = useCallback(async (setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/cadaver/estatistica/pormes/porregional')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesMesAsync = useCallback(async (setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/pormes/porregional')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getVestigiosRecebidosSetorMesAsync = useCallback(async (sectorId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get(`/vestigios/estatistica/recebidos/noSetor/pormes/${sectorId}`)
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesSolicitadosSetorMesAsync = useCallback(async (sectorId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get(`/exameSolicitado/estatistica/solicitados/nosetor/pormes/${sectorId}`)
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesAtribuidosUsuarioMesAsync = useCallback(async (userId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/atribuidos/usuario/pormes')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getExamesFinalizadosUsuarioMesAsync = useCallback(async (userId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/finalizados/usuario')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  // --- Table Fetches (Lists of latest activities, 5 rows) ---

  const getLatestCadaversAsync = useCallback(async (setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/cadaver/estatistica/ultimoscadaveres')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getLatestExamsAssignedAsync = useCallback(async (userId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/ultimosatribuidos/usuario')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  const getLatestExamsRequestedAsync = useCallback(async (userId, setProcessing) => {
    try {
      if (setProcessing) setProcessing(true)
      const response = await fetch.get('/exameSolicitado/estatistica/ultimossolicitados/usuario')
      return response.data
    } finally {
      if (setProcessing) setProcessing(false)
    }
  }, [fetch])

  return {
    getCadaveresDiaAsync,
    getExamesDiaAsync,
    getVestigiosDiaAsync,
    getVestigiosSetorAsync,
    getVestigiosUsuarioAsync,
    getExamesAtribuidosUsuarioAsync,
    getExamesSolicitadosSetorAsync,
    getCadaveresMesAsync,
    getExamesMesAsync,
    getVestigiosRecebidosSetorMesAsync,
    getExamesSolicitadosSetorMesAsync,
    getExamesAtribuidosUsuarioMesAsync,
    getExamesFinalizadosUsuarioMesAsync,
    getLatestCadaversAsync,
    getLatestExamsAssignedAsync,
    getLatestExamsRequestedAsync,
  }
}
